import { useState } from "react";
import { initialStepData } from "../data/steps";

export const useAIQuoteSteps = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedType, setSelectedType] = useState("design");
  const [userData, setUserData] = useState(initialStepData);

  return {
    currentStep,
    selectedType,
    userData,
    setCurrentStep,
    setSelectedType,
    setUserData,
  };
};
